// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_72-0";